'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var propTypes = {
  children: _react.PropTypes.node,
  inline: _react.PropTypes.bool,
  tag: _react.PropTypes.string,
  className: _react.PropTypes.string
};

var defaultProps = {
  tag: 'form'
};

var Form = function Form(props) {
  var className = props.className;
  var inline = props.inline;
  var Tag = props.tag;

  var attributes = _objectWithoutProperties(props, ['className', 'inline', 'tag']);

  var classes = (0, _classnames2.default)(className, inline ? 'form-inline' : false);

  return _react2.default.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Form.propTypes = propTypes;
Form.defaultProps = defaultProps;

exports.default = Form;


/*****************
 ** WEBPACK FOOTER
 ** ./~/reactstrap/lib/Form.js
 ** module id = 171
 ** module chunks = 0
 **/